import { render, staticRenderFns } from "./menu4_active_learning.vue?vue&type=template&id=1a587114&scoped=true"
import script from "./menu4_active_learning.vue?vue&type=script&lang=js"
export * from "./menu4_active_learning.vue?vue&type=script&lang=js"
import style0 from "./menu4_active_learning.vue?vue&type=style&index=0&id=1a587114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a587114",
  null
  
)

export default component.exports